import UINineSliceComponent from '../../Component/UI/NineSlice';
import GameObject from '../../GameObject/GameObject';
import BackcardItem from './BackCardItem';
import Element from './Element';

export default class BackCardCollectionItem extends Element {
    public create(params: any): void {
        super.create({
            type: 'group',
            name: 'back_card_collection_item',
            layout: {
                anchors: [0, 0, 1, 0],
                offsets: [0, 0, 0, 0],
                pivot: [0.5, 0],
                constrains: {
                    heightMin: 344,
                    heightMax: 344,
                    widthMin: 492,
                    widthMax: 492,
                },
            },
            components: [
                {
                    type: 'nineslice',
                    data: {
                        cacheKey: 'rounded_rectangle1_9_slice',
                        offset: [15, 15, 15, 15],
                    },
                },
            ],
            ...params,
        });
    }

    protected onCreate(params: any): void {
        super.onCreate(params);

        this.getComponent(UINineSliceComponent).tint = 0xffbe82;

        // Title.
        const title: Element = GameObject.Instantiate(Element, {
            type: 'group',
            name: 'title',
            layout: {
                anchors: [0.5, 0, 0.5, 0],
                pivot: [0.5, 0.5],
                offsets: [0, -45, 0, -45],
            },
            components: [
                {
                    type: 'text',
                    data: {
                        textLocalizationKey: params.type,
                        style: {
                            font: 'RussoOne',
                            fill: '#512415',
                            fontSize: '34px',
                        },
                        align: 'center',
                        wordWrap: true,
                        wordWrapWidth: 400,
                    },
                },
            ],
        });
        this.addChild(title);

        // First.
        this.addChild(
            GameObject.Instantiate(BackcardItem, {
                layout: {
                    anchors: [0.18, 0.5, 0.18, 0.5],
                    pivot: [0.5, 0.5],
                    offsets: [0, 0, 0, 0],
                },
                id: params.cards[0],
                unlocked: params.unlocked[0],
            })
        );

        // Second.
        this.addChild(
            GameObject.Instantiate(BackcardItem, {
                layout: {
                    anchors: [0.5, 0.5, 0.5, 0.5],
                    pivot: [0.5, 0.5],
                    offsets: [0, 0, 0, 0],
                },
                id: params.cards[1],
                unlocked: params.unlocked[1],
            })
        );

        // Third.
        this.addChild(
            GameObject.Instantiate(BackcardItem, {
                layout: {
                    anchors: [0.82, 0.5, 0.82, 0.5],
                    pivot: [0.5, 0.5],
                    offsets: [0, 0, 0, 0],
                },
                id: params.cards[2],
                unlocked: params.unlocked[2],
            })
        );
    }
}
